import { ShortCode } from '@highereducation/wordpress';
import { CarouselItem, type CarouselItemProps } from '@highereducation/hen-ui';

type CarouselItemShortcodeProps = {
  basis?: CarouselItemProps['basis'];
  children?: React.ReactNode;
};

export const CarouselItemShortcode: ShortCode<CarouselItemShortcodeProps> = {
  component: ({ basis, children }) => {
    return <CarouselItem basis={basis}>{children}</CarouselItem>;
  },
};
